import Vue from "vue";
import Router from "vue-router";
import RouterPermission from "./middleware/permission";
import { store } from "../store";
import configRoutes from "./routes";
Vue.use(Router);

const router = new Router({
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;
  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  store.commit("setCurrentLanguage", 1);

  if (to.meta.requiresAuth) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : RouterPermission;

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware({ ...context, next: nextMiddleware });
  }

  return next();
});
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  if (pattern.test(error.message)) {
    console.log("Chunk load error, clearing cache and reloading");
    caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
    window.location.reload();
  }
});

export default router;
